"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Filter1: ['filter-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.826,3.58A2.251,2.251,0,0,0,21.01,0H2.992A2.25,2.25,0,0,0,1.164,3.563l7.1,10.171v8.015A2.259,2.259,0,0,0,10.716,24a2.9,2.9,0,0,0,1.573-.408c2.733-1.7,2.445-1.524,2.471-1.543a2.261,2.261,0,0,0,.9-1.8V13.737Zm-9.437,9.04a1.25,1.25,0,0,0-.229.721v6.481a.5.5,0,0,1-.244.43c-.328.194-.923.547-1.405.827a.5.5,0,0,1-.751-.432V13.341a1.242,1.242,0,0,0-.225-.715L4.018,3.287a.5.5,0,0,1,.41-.786H19.563a.5.5,0,0,1,.409.788Z']],
  Filter: ['filter', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.59,9.328a6.057,6.057,0,0,0,.91-2.919V4.159c0-1.246-2.515-4.066-10-4.066S1.5,2.91,1.5,4.159v2.25a6.024,6.024,0,0,0,1.562,3.767L9.5,16.616v5.793a1.5,1.5,0,0,0,1.5,1.5h1a1.5,1.5,0,0,0,1.5-1.5V19.893A6.481,6.481,0,0,0,20.59,9.328ZM11.5,2.093c4.963,0,8,1.559,8,2.407s-3.037,2.409-8,2.409S3.5,5.35,3.5,4.5,6.537,2.093,11.5,2.093ZM16,18.409a4.53,4.53,0,0,1-2.374-.677.251.251,0,0,1-.126-.217v-.8a.251.251,0,0,1,.073-.177l5.5-5.5a.251.251,0,0,1,.369.016A4.45,4.45,0,0,1,20.5,13.909,4.505,4.505,0,0,1,16,18.409Z']],
  Filter2: ['filter-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.894.552A1,1,0,0,0,23,0H1A1,1,0,0,0,.2,1.6L9,13.423V22a2.015,2.015,0,0,0,2,2,1.993,1.993,0,0,0,1.2-.4l2-1.5a2.007,2.007,0,0,0,.8-1.6V13.423L23.8,1.6A1,1,0,0,0,23.894.552ZM5.417,2.2l3.939,5.25a.5.5,0,0,1,.1.3V9a.5.5,0,0,1-.9.3L3.62,2.8a.5.5,0,0,1,.4-.8h1A.5.5,0,0,1,5.417,2.2Z']],
  FilterText: ['filter-text', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.1,3.318A2,2,0,0,0,14.592,0H2A2,2,0,0,0,.494,3.318l5.3,6.06v5.255A2,2,0,0,0,8.9,16.3l1-.666a2,2,0,0,0,.892-1.665V9.377l5.3-6.059ZM5.371,6.078l-2.81-3.25A.5.5,0,0,1,2.94,2h1a.5.5,0,0,1,.37.164l1.81,2a.5.5,0,0,1,.13.336v1.25a.5.5,0,0,1-.879.327Z', 'M18,14.751h2a.75.75,0,0,0,0-1.5H18a.75.75,0,0,0,0,1.5Z', 'M16,17.751h4a.75.75,0,0,0,0-1.5H16a.75.75,0,0,0,0,1.5Z', 'M16,20.751h4a.75.75,0,0,0,0-1.5H16a.75.75,0,0,0,0,1.5Z', 'M22,10H14a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V12A2,2,0,0,0,22,10Zm0,11.75a.25.25,0,0,1-.25.25h-7.5a.25.25,0,0,1-.25-.25v-9.5a.25.25,0,0,1,.25-.25h7.5a.25.25,0,0,1,.25.25Z']]
};
exports["default"] = _default;